<template>
  <b-modal
    v-model="visible"
    :title="messages.PENALIDAD_MODAL_TITLE"
    size="lg"
    modal-class="gestor-centralizado-penalidad-modal"
    @hidden="handleHidden"
  >
    <div v-if="penalidadDraft">
      <b-table
        small
        bordered
        :items="[penalidadDraft]"
        :fields="penalidadFields"
      >
        <template #cell(tipoId)="{ item }">
          <div
            v-if="item.codigo"
            class="d-flex align-items-start justify-content-between"
          >
            <div class="pr-2">
              <div class="font-weight-bold">{{ item.codigo }}</div>
              <div class="small text-muted gc-col-wrap">{{ item.descripcion }}</div>
            </div>
            <b-badge :variant="esManualCodigo(item.codigo) ? 'secondary' : 'warning'">
              {{ esManualCodigo(item.codigo) ? "Aplicada" : "Automática" }}
            </b-badge>
          </div>
          <b-form-select
            v-else
            v-model="item.tipoId"
            :options="catalogOptions"
            class="grey-input"
            @change="handleTipoChange(item)"
          />
        </template>

        <template #cell(descripcion)="{ item }">
          <div>{{ item.descripcion || "-" }}</div>
          <div
            v-if="selectedTipo && selectedTipo.requierePrecioMercaderia"
            class="mt-2"
          >
            <small class="text-grey">Precio mercadería devuelta (S/)</small>
            <b-form-input
              v-model.number="item.precioMercaderia"
              type="number"
              step="0.01"
              min="0"
              class="grey-input"
              @input="handleRecalculate(item)"
            />
          </div>
          <div v-if="selectedTipo && selectedTipo.requiereFlete" class="mt-2">
            <small class="text-grey">Flete (S/)</small>
            <b-form-input
              v-model.number="item.flete"
              type="number"
              step="0.01"
              min="0"
              class="grey-input"
              @input="handleRecalculate(item)"
            />
          </div>
        </template>

        <template #cell(monto)="{ item }">
          <b-form-input
            v-model.number="item.monto"
            type="number"
            step="0.01"
            min="0"
            class="grey-input text-right"
            disabled
          />
        </template>

        <template #cell(acciones)>
          <b-button
            size="sm"
            variant="outline-danger"
            @click="$emit('delete-penalidad')"
          >
            {{ messages.PENALIDAD_DELETE_BUTTON }}
          </b-button>
        </template>
      </b-table>

      <div class="text-right mt-2">
        <div class="text-grey small">Total penalidades (OS)</div>
        <div class="font-weight-bold text-danger">
          S/ {{ totalPenalidad.toFixed(2) }}
        </div>
      </div>
    </div>

    <template #modal-footer>
      <b-button class="bg-grey-btn" @click="visible = false">
        {{ messages.PENALIDAD_CANCEL_BUTTON }}
      </b-button>
      <b-button
        class="bg-orange-btn"
        :disabled="!canSavePenalidad"
        @click="$emit('save-penalidad')"
      >
        {{ messages.PENALIDAD_SAVE_BUTTON }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { MESSAGES, getPenalidadModalFields } from "@/services/gestor-centralizado/gestor-centralizado.constants";

export default {
  name: "GestorCentralizadoPenalidadModal",

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    penalidadDraft: {
      type: Object,
      default: null,
    },
    catalog: {
      type: Array,
      default: () => [],
    },
    totalConIgv: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      messages: MESSAGES,
      penalidadFields: getPenalidadModalFields(),
    };
  },

  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(nextValue) {
        this.$emit("input", nextValue);
      },
    },

    catalogOptions() {
      return [
        { value: null, text: "Seleccione...", disabled: true },
        ...this.catalog
          .filter((item) => item.activo !== false && item.permiteEditarMonto !== false)
          .sort((a, b) => (a.filaOrigen ?? 0) - (b.filaOrigen ?? 0))
          .map((item) => ({
            value: item.id,
            text: `${item.codigo} - ${item.descripcion}`,
          })),
      ];
    },

    selectedTipo() {
      const tipoId = this.penalidadDraft?.tipoId;
      if (!tipoId) return null;
      return this.catalog.find((item) => item.id === tipoId) || null;
    },

    totalPenalidad() {
      return Number(this.penalidadDraft?.monto ?? 0);
    },

    canSavePenalidad() {
      if (!this.penalidadDraft?.tipoId) return false;

      const tipo = this.selectedTipo;
      if (!tipo) return false;

      if (tipo.reglaTipo === "PRECIO_MERCADERIA_DEVUELTA") {
        const precio = Number(this.penalidadDraft.precioMercaderia || 0);
        const flete = Number(this.penalidadDraft.flete || 0);
        return precio + flete > 0;
      }

      return Number(this.penalidadDraft.monto || 0) >= 0;
    },
  },

  methods: {
    handleHidden() {
      this.$emit("hidden");
    },

    handleTipoChange(item) {
      this.$emit("tipo-change", item);
    },

    handleRecalculate(item) {
      this.$emit("recalculate", item);
    },

    esManualCodigo(codigo) {
      const tipo = this.catalog.find((t) => t.codigo === codigo);
      return tipo?.permiteEditarMonto === true;
    },
  },
};
</script>